import { useContext, useRef } from "react";

import { AiOutlineInfo } from "react-icons/ai";

import { useTranslator } from "@eo-locale/react";

import { useRouter } from "next/router";

import Cookies from "js-cookie";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  IconButton,
  Box,
  Button,
  FiInfo,
  FiHelpCircle,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useMediaQuery,
  FiShare2,
  SocialShare
} from "@/storybook-components";

import AboutPlaces from "./about";
import PlacesHelp from "./help";

import { useAppSelector } from "@/redux/store/hooks";
import { EsriContext } from "../../context/esri-context";
import { EsriContextType } from "../../context/esri-context-type";

interface IMapDetails {
  rightPanelProps: any;
}

const MapDetails = ({ rightPanelProps }: IMapDetails) => {
  const { translate } = useTranslator();
  const btnRef = useRef(null);
  const [isDesktop] = useMediaQuery("(min-width: 768px)");
  const { baseUrl } = useAppSelector((state) => state.adapter.adapter);
  const toolName = useAppSelector((state) => state.place.place.name);
  const {
    query: { projectId, placesId }
  } = useRouter();
  const { settings } = useAppSelector((state) => state.settings);
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const { openInfoModal, isInfoModalOpen, closeInfoModal } = useContext(
    EsriContext
  ) as EsriContextType;

  const closeInfoModalAndNavigateToMap = () => {
    Cookies.remove("trigger_point");
    closeInfoModal();
    rightPanelProps.onClose();
  };

  const tabList = () => {
    return (
      <TabList>
        <Tab width={"50%"} leftIcon={FiInfo}>
          {`${translate("places.aboutUs")}`}
        </Tab>
        <Tab width={"50%"} leftIcon={FiHelpCircle}>
          {translate("places.help")}
        </Tab>
      </TabList>
    );
  };
  const tabPanel = () => {
    return (
      <TabPanels>
        <TabPanel p={2}>
          <AboutPlaces />
        </TabPanel>
        <TabPanel p={2}>
          <PlacesHelp />
        </TabPanel>
      </TabPanels>
    );
  };

  return (
    <>
      <Box display={{ base: "auto", lg: "flex", sm: "none" }} gap={3}>
        <IconButton
          ref={btnRef}
          size="md"
          boxShadow="md"
          variant="solid"
          borderRadius="50%"
          bg="white"
          color="gray.900"
          _hover={{ background: "gray.100", color: "gray.900" }}
          onClick={openInfoModal}
          icon={<AiOutlineInfo />}
          aria-label={translate("places.infoIcon")}
        />
        {!settings.disableSocialMediaSharing && (
          <SocialShare
            placement={isMobile ? "auto-end" : "auto"}
            trigger={
              <IconButton
                size="md"
                boxShadow="md"
                variant="solid"
                borderRadius="50%"
                bg="white"
                color="gray.900"
                _hover={{ background: "gray.100", color: "gray.900" }}
                icon={<FiShare2 />}
                aria-label={translate("places.shareAriaLabel")}
              />
            }
            title={toolName}
            shareUrl={`${baseUrl}/${projectId}/places/${placesId}`}
          />
        )}
      </Box>

      <Modal
        onClose={closeInfoModal}
        finalFocusRef={btnRef}
        isOpen={isInfoModalOpen}
        size={!isDesktop ? "xs" : "md"}
        isCentered
        id="places-help-modal"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader> {/** requierd for top spacing */}
          <ModalCloseButton />
          <ModalBody>
            <Tabs colorScheme="gray" size="md" variant="soft-rounded">
              {tabList()}
              {tabPanel()}
            </Tabs>
          </ModalBody>
          <ModalFooter pt={6} pb={6}>
            <Button
              variant="primary"
              width={"100%"}
              onClick={closeInfoModalAndNavigateToMap}
            >
              {translate("places.viewMap")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default MapDetails;
